import { useSelector } from "react-redux";
import { genderTypes } from "../enums/genderTypes";

function useTextByLangAndGender() {

    const lang = useSelector(state => state.translate.lang)
    const genderId = useSelector(state => state.auth.userDetails?.genderId); 

    return (children) => {
        if (typeof children === 'string') {
            return children
        }

        if (children && typeof children === 'object') {
            if (Object.keys(children).some(key => Object.values(genderTypes).includes(key))) { // support jsones without genders
                return children[genderTypes[genderId]] ? children[genderTypes[genderId]][lang] : children[genderTypes[9]][lang]
            }
            else {
                return children[lang]
            }
        }

        return null
    }
}

export default useTextByLangAndGender;
